(function(root){
  'use strict';
  const catalogue=typeof module!=='undefined' && module.exports?require('./catalogue.js'):root.BundleCatalogue;
  const pricing=typeof module!=='undefined' && module.exports?require('./pricing.js'):root.BundlePricing;
  function create(){
    let groups=[],nextKey=1;
    function addBundle(id){
      const bundle=catalogue.bundles.find(item=>item.id===id);
      if(!bundle)throw new RangeError('Unknown bundle.');
      const key=nextKey++;
      groups.push({key,id,name:bundle.name,lines:catalogue.products.flatMap((product,index)=>bundle.quantities[index]?[{
        id:product.id,color:product.defaultColor,size:'M',quantity:bundle.quantities[index],price:product.price,
      }]:[])});
      return key;
    }
    function setSize(key,id,size){
      if(!['M','L','XL'].includes(size))throw new RangeError('Choose M, L or XL.');
      const row=groups.find(group=>group.key===key)?.lines.find(line=>line.id===id);
      if(!row)throw new RangeError('Unknown cart selection.');
      row.size=size;
    }
    function setColor(key,id,color){
      const group=groups.find(group=>group.key===key);
      const row=group?.lines.find(line=>line.id===id);
      if(!row)throw new RangeError('Unknown cart selection.');
      if(group.id!=='winter')throw new RangeError('This bundle uses the pictured colors.');
      const product=catalogue.products.find(product=>product.id===id);
      if(!product.colors.includes(color))throw new RangeError('Choose an available color.');
      row.color=color;
    }
    function removeBundle(key){groups=groups.filter(group=>group.key!==key);}
    function snapshot(){
      const copy=groups.map(group=>({...group,lines:group.lines.map(row=>({...row}))}));
      return {groups:copy,quote:pricing.quote(copy.flatMap(group=>group.lines))};
    }
    return {addBundle,setSize,setColor,removeBundle,snapshot};
  }
  const api={create};
  if(typeof module!=='undefined' && module.exports)module.exports=api;
  else root.BundleCart=api;
})(typeof globalThis!=='undefined'?globalThis:this);
